export const queryKeys = {
    getEmailTemplate: "getEmailTemplate",
    getEmailTemplates: "getEmailTemplates",
  };
  